import styled from "styled-components";
import SucessImg from "./img/sucess.png"

function OperationSucess() {
    return(
    <Sucess>
        Operação foi realizada com sucesso! <Icon/>
    </Sucess>
    )
}

export default OperationSucess;

const Sucess = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 50px;
    background-color: white;
    border-radius: 10px;
    font-size: 30px;
    border: solid 1px black;
    box-shadow: 10px 10px 10px 0px black;

`

const Icon = styled.div`
    background-image: url(${SucessImg});
    background-size: cover;
    background-repeat: no-repeat;
    backgroun-position: center center;
    width: 50px;
    height: 50px;
    margin-left: 20px;

`

